import React, { useContext } from 'react';

import filter from '../../../assets/images/svg/filter.svg';
import { ProjectsContext } from '../../../views/dashboard/lender/investment/projects/ProjectsContext';
import { Image } from '../../common';

import './FilterIcon.scoped.scss';

type Props = {
  active?: boolean;
  onClick?: () => void;
};

const FilterIcon = ({ active, onClick }: Props) => {
  const context = useContext(ProjectsContext);
  const isActive = active ?? context.filterActive;
  const toggle = onClick ?? context.toggleFilter;
  return (
    <Image
      src={filter}
      alt={'filter'}
      className={isActive ? 'filter__icon__active' : 'filter__icon'}
      onClick={toggle}
    />
  );
};

export default FilterIcon;
